var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJoinButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.0567 1.5H14.5962C15.6479 1.5 16.5001 2.35939 16.5001 3.41997V5.98089C16.5001 7.04148 15.6479 7.90087 14.5962 7.90087H12.0567C11.005 7.90087 10.1528 7.04148 10.1528 5.98089V3.41997C10.1528 2.35939 11.005 1.5 12.0567 1.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40389 1.5H5.94337C6.99507 1.5 7.84726 2.35939 7.84726 3.41997V5.98089C7.84726 7.04148 6.99507 7.90087 5.94337 7.90087H3.40389C2.35219 7.90087 1.5 7.04148 1.5 5.98089V3.41997C1.5 2.35939 2.35219 1.5 3.40389 1.5ZM3.40389 10.0991H5.94337C6.99507 10.0991 7.84726 10.9585 7.84726 12.0191V14.58C7.84726 15.6399 6.99507 16.5 5.94337 16.5H3.40389C2.35219 16.5 1.5 15.6399 1.5 14.58V12.0191C1.5 10.9585 2.35219 10.0991 3.40389 10.0991ZM14.5961 10.0991H12.0566C11.0049 10.0991 10.1527 10.9585 10.1527 12.0191V14.58C10.1527 15.6399 11.0049 16.5 12.0566 16.5H14.5961C15.6478 16.5 16.5 15.6399 16.5 14.58V12.0191C16.5 10.9585 15.6478 10.0991 14.5961 10.0991Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinButton);
export default __webpack_public_path__ + "static/media/join-button.a526c2274d9aa276b9cc93a9042fc4f3.svg";
export { ForwardRef as ReactComponent };